<app-vc-input
  name="companyName"
  label="labels.companyName"
  [control]="companyName()"
  [placeholder]="'placeholders.companyName' | translate"
  [required]="true"
  (valueChange)="onCompanyChange($event)"
  (blurred)="onCompanyBlur()"
  (enter)="enter.emit()"
/>

<app-vc-input
  name="domain"
  label="labels.domainName"
  [control]="domain()"
  [placeholder]="'placeholders.domain' | translate"
  suffix=".vouchercart.com"
  [required]="true"
  tooltipKey="tooltips.domainTooltip"
  maxLengthMessage="The URL of your sales page can not be longer than 60 characters"
  (valueChange)="onDomainChange($event)"
  (enter)="enter.emit()"
/>
